import { create } from "zustand";

type HiddenUsersStore = {
  hiddenIds: Set<string>;
  hide: (userId: string) => void;
};

export const useHiddenUsersStore = create<HiddenUsersStore>((set) => ({
  hiddenIds: new Set(),
  hide: (userId) =>
    set((state) => {
      const next = new Set(state.hiddenIds);
      next.add(userId);
      return { hiddenIds: next };
    }),
}));
